import { action, computed, decorate, observable } from "mobx";

class Sort {
  isDesc = true;
  isEnabled = false;
  fieldName = "";

  setIsDescFromValue(value) {
    this.isDesc = value === "desc" ? true : false;
  }

  get pitsQuery() {
    return `${this.fieldName} ${this.isDesc ? "DESC" : "ASC"}`;
  }
}

decorate(Sort, {
  fieldName: observable,
  isDesc: observable,
  isEnabled: observable,
  setIsDescFromValue: action,
  pitsQuery: computed
});

export default Sort;



// WEBPACK FOOTER //
// ./src/models/Sort.js